module.exports = __webpack_public_path__ + "static/arrow-b2e6affa8d41958fb51e7fcf1bc32a36.png";